import React, { useState, useEffect, useContext } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { UserContext } from "../../contexts/UserContext";
import UnifiedSidebar from "./UnifiedSidebar";
import RouteGuard from "../RouteGuard";
import HelpButton from "../HelpButton";
import PhoneBook from "../user/PhoneBook";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UnifiedLayout = () => {
  const location = useLocation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [showPhoneBook, setShowPhoneBook] = useState(false);
  const [viewMode, setViewMode] = useState('admin'); // 'admin' lub 'user' - dla przełączania widoku przez admina
  const { user } = useContext(UserContext);

  // Adjust sidebar state based on route
  useEffect(() => {
    const path = location.pathname;

    // Routes where sidebar should start collapsed
    const collapsedRoutes = [
      "/trainings",
      "/daily-task-coordination/live-map",
    ];

    // Routes where sidebar should start expanded
    const expandedRoutes = [
      "/dashboard",
      "/admin",
      "/users",
      "/profile",
      "/settings",
      "/my-",
    ];

    const shouldBeCollapsed = collapsedRoutes.some(route => path === route);
    const shouldBeExpanded = expandedRoutes.some(route => path.startsWith(route));

    if (shouldBeCollapsed) {
      setSidebarCollapsed(true);
    } else if (shouldBeExpanded) {
      setSidebarCollapsed(false);
    }
  }, [location.pathname]);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  useEffect(() => {
    document.body.style.overflow = "auto";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div className="h-screen w-screen bg-slate-50 flex overflow-hidden">
      <UnifiedSidebar
        collapsed={sidebarCollapsed}
        toggleCollapse={toggleSidebar}
        setSidebarCollapsed={setSidebarCollapsed}
        onOpenPhoneBook={() => setShowPhoneBook(true)}
        viewMode={viewMode}
        setViewMode={setViewMode}
      />
      <main className="flex-1 h-full overflow-y-auto">
        <RouteGuard>
          <Outlet context={{ sidebarCollapsed, viewMode }} />
        </RouteGuard>
      </main>

      {/* Phone Book Modal */}
      <PhoneBook isOpen={showPhoneBook} onClose={() => setShowPhoneBook(false)} />

      <HelpButton />
      <ToastContainer position="top-center" autoClose={3000} />
    </div>
  );
};

export default UnifiedLayout;
